import React, { useEffect } from 'react'
import Pagination from '../nav/Pagination'
import Empty from '../feedback/Empty'
import utils from '../../utils'
import moment from 'moment'

function OrdersTable(props) {
    const payments = props.payments
    useEffect(() => { }, [payments])
    return (
        <div className='p-3 bg-white dark:bg-slate-800 rounded-lg shadow-sm hover:shadow-md overflow-hidden border border-border-light dark:border-border-dark'>
            <div className='overflow-x-auto'>
                <table className="table table-compact table-zebra w-full">
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th className='hidden md:table-cell'>Purchases</th>
                            <th className='hidden md:table-cell'>Price (KSH)</th>
                            <th className='hidden md:table-cell'>Method</th>
                            <th className='hidden md:table-cell'>Status</th>
                            <th className='hidden md:table-cell'>Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments?.results?.map((payment, idx) => (
                            <tr key={idx}>
                                <td className=''>
                                    <div className="flex gap-3 items-center">
                                        <div className="hidden md:avatar placeholder">
                                            <div className="bg-neutral text-white rounded-full w-11">
                                                <span className="text-lg">{utils.makeProfileLetter(payment?.customer_profile)}</span>
                                            </div>
                                        </div>
                                        <div>
                                            {payment?.customer_profile?.full_name && (
                                                <p className='font-bold'>
                                                    {payment?.customer_profile?.full_name}
                                                </p>
                                            )}
                                            <p className='text-gray-600'>
                                                {payment?.customer_profile?.email}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td className='hidden md:table-cell'>
                                    {
                                        payment?.get_cart_items?.reduce((accumulator, item) => {
                                            return accumulator + item.quantity;
                                        }, 0)
                                    }
                                </td>
                                <td className='font-bold hidden md:table-cell'>{utils.toCommas(payment?.total)}</td>
                                <td className='hidden md:table-cell'>{payment?.payment_method}</td>
                                <td className='hidden md:table-cell'>{payment?.status}</td>
                                <td className='font-bold hidden md:table-cell'>{moment(payment?.creation_time).format("MMMM Do YYYY")}</td>
                                <td>
                                    <button
                                        onClick={() => props.openModal(payment)}
                                        className='btn btn-sm btn-primary'>View</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {payments?.count < 1 ? (
                    <Empty objectName={"payments"} />
                ) : null}
                {payments?.count ? (
                    <div className='mt-8 flex justify-center'>
                        <Pagination
                            count={payments?.count}
                            next={payments?.next}
                            previous={payments?.previous}
                            changePageParam={props.changePageParam}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default OrdersTable